/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".contact-picture[_ngcontent-%COMP%]{margin-left:-15px;margin-right:-15px}.contact-picture[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;-o-object-fit:cover;object-fit:cover;border-radius:10px 10px 0 0}.contact-card[_ngcontent-%COMP%]{box-shadow:0 5px 8px 0 rgba(0,0,0,.1);background-position:bottom right;background-repeat:no-repeat}.contact-card[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:10px 0 0;font-size:14px;line-height:1.42857143}\n/*# sourceMappingURL=geodestino-contact-item.component.css.map*/"];
export { styles as styles };
